export default __webpack_public_path__ + "static/media/icon-value-Efficiencies.6db4e90f.svg";